// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1ymAQ","overflowing":"ReadFullNote_overflowing__1hiV5"};